import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { i18n } from 'core/localization';
import { ErrorModal } from 'framework/show-error-modal/showErrorModal';
import React from 'react';

export function showError(response: { message: string; details?: string[] }) {
	return openModal(
		{
			title: i18n('Error'),
			width: 600,
			resizable: false,
			defaultFooterButtons: ['ok'],
			okText: i18n('Ok'),
			positionType: ModalPosition.Centered,
		},
		<ErrorModal response={response} />,
	);
}
